import { render, staticRenderFns } from "./DialogListCalendar.vue?vue&type=template&id=018673fa&scoped=true&"
import script from "./DialogListCalendar.vue?vue&type=script&lang=js&"
export * from "./DialogListCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DialogListCalendar.vue?vue&type=style&index=0&id=018673fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018673fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDialog,VRow})
